
import { useState } from 'react';

export default function Itinerary() {
  const [activeTab, setActiveTab] = useState<'2-island' | '3-island'>('2-island');

  const tour2Island = [
    {
      day: 'Ngày 1',
      title: 'Việt Nam → Honolulu',
      activities: [
        'Bay đến Honolulu',
        'Nhận xe tự lái',
        'Check-in khách sạn',
        'Tự do khám phá Waikiki'
      ]
    },
    {
      day: 'Ngày 2',
      title: 'Trân Châu Cảng & Polynesian',
      activities: [
        'Tham quan Trân Châu Cảng',
        'Chiến hạm USS Arizona',
        'Trung tâm văn hóa Polynesian',
        'Show văn hóa đặc sắc'
      ]
    },
    {
      day: 'Ngày 3',
      title: 'Đảo Mini Circle Tour',
      activities: [
        'Vịnh Hanauma',
        'Lỗ phun nước Halona',
        'Bãi biển Sandy',
        'Đài quan sát Pali',
        'Ngắm toàn cảnh Oahu'
      ]
    },
    {
      day: 'Ngày 4',
      title: 'Bay sang Đảo Lớn',
      activities: [
        'Bay đến Hilo',
        'Chợ nông sản địa phương',
        'Thác Rainbow',
        'Kealakekua Bay'
      ]
    },
    {
      day: 'Ngày 5',
      title: 'Công viên Núi lửa',
      activities: [
        'Công viên núi lửa quốc gia',
        'Thác Akaka',
        'Thung lũng Waipio',
        'Ngắm dung nham'
      ]
    },
    {
      day: 'Ngày 6',
      title: 'Trở về Honolulu',
      activities: [
        'Bay về Honolulu',
        'Tự do mua sắm',
        'Kết thúc tour 2 đảo'
      ]
    }
  ];

  const tour3Island = [
    ...tour2Island,
    {
      day: 'Ngày 7',
      title: 'Maui - Haleakalā & Hana Road',
      activities: [
        'Bay sang Maui',
        'Núi Haleakalā',
        'Đường đến Hana lãng mạn',
        'Wailea Beach',
        'Old Lahaina Luau'
      ]
    },
    {
      day: 'Ngày 8',
      title: 'Bay về Honolulu',
      activities: [
        'Tự do khám phá Maui buổi sáng',
        'Bay về Honolulu chiều'
      ]
    },
    {
      day: 'Ngày 9-10',
      title: 'Honolulu → Việt Nam',
      activities: [
        'Tự do mua sắm',
        'Bay về Việt Nam',
        'Kết thúc hành trình'
      ]
    }
  ];

  const currentItinerary = activeTab === '2-island' ? tour2Island : tour3Island;

  return (
    <section id="itinerary" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Lịch trình <span className="text-[#2563eb]">chi tiết</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Chọn tour phù hợp với thời gian của bạn
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-12">
          <div className="bg-gray-100 rounded-full p-1 inline-flex">
            <button
              onClick={() => setActiveTab('2-island')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === '2-island'
                  ? 'bg-[#2563eb] text-white shadow-lg'
                  : 'text-gray-600 hover:text-[#2563eb]'
              }`}
            >
              Tour 2 Đảo (5N4Đ)
            </button>
            <button
              onClick={() => setActiveTab('3-island')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === '3-island'
                  ? 'bg-[#2563eb] text-white shadow-lg'
                  : 'text-gray-600 hover:text-[#2563eb]'
              }`}
            >
              Tour 3 Đảo (7N6Đ)
            </button>
          </div>
        </div>

        {/* Timeline */}
        <div className="max-w-4xl mx-auto">
          {currentItinerary.map((day, index) => (
            <div key={index} className="relative pl-8 pb-8 last:pb-0">
              {/* Timeline line */}
              {index !== currentItinerary.length - 1 && (
                <div className="absolute left-3 top-8 bottom-0 w-0.5 bg-[#dbeafe]"></div>
              )}
              
              {/* Timeline dot */}
              <div className="absolute left-0 top-1 w-6 h-6 bg-[#2563eb] rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>

              {/* Content */}
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
                  <h3 className="text-xl font-bold text-[#2563eb]">{day.day}</h3>
                  <span className="text-gray-500 text-sm">{day.title}</span>
                </div>
                <ul className="space-y-2">
                  {day.activities.map((activity, idx) => (
                    <li key={idx} className="flex items-start text-gray-600">
                      <i className="ri-checkbox-circle-fill text-[#2563eb] mr-2 mt-0.5 flex-shrink-0"></i>
                      {activity}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
          <a
            href="#final-cta"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            Xem lịch trình chi tiết
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <div>
            <a
              href="#"
              className="inline-flex items-center text-[#2563eb] font-semibold hover:underline cursor-pointer"
            >
              Tải PDF tour 3 đảo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
